import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { NotificationsByIdName } from '../name';
import { notificationsGetSlice } from '../../@async/get';
import { PatchNotificationsByIdRequest } from '../../../api';

export const updateNotificationsById = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: NotificationsByIdName,
	state: notificationsGetSlice.asyncState,
	target: (data: PatchNotificationsByIdRequest) => (notification) => notification.notificationId === data.id,
	update: () => (notification) => ({
		...notification,
		isRead: true
	})
});
